/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Input, Table, Button, Select, Tag, Tooltip, Dropdown, Space, message, Popconfirm, Avatar } from 'antd';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import moment from 'moment';
import UilCreditCard from '@iconscout/react-unicons/icons/uil-credit-card';
import { UilBookAlt } from '@iconscout/react-unicons';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';
import UilFire from '@iconscout/react-unicons/icons/uil-fire';
import UilLock from '@iconscout/react-unicons/icons/uil-lock-alt';
import UilUnLock from '@iconscout/react-unicons/icons/uil-unlock-alt';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import { DownloadOutlined, DownOutlined } from '@ant-design/icons';

import FormDialog from './FormDialog';
import TrainingsSelection from './TrainingsSelection';
import { TableWrapper } from '../../../container/styled';
import { BtnWithIcon, Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { themeColor } from '../../../config/theme/themeVariables';
import { ImagePreview } from '../../common';
import EndEmployement from '../../common/end-employment';
import { API_ENDPOINT, EMP_STATUS_FILTER } from '../../../config/config';


const { Option } = Select;

function DataTable() {
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState('');
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [showForm, setShowForm] = useState(false);
  const [editID, setEditID] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [busy, setBusy] = useState(false);
  const [activeStatus, setActiveStatus] = useState(1);
  const [reload, setReload] = useState(false);
  const [showEndEmp, setShowEndEmp] = useState(false);
  const [shwoTrainingReq, setShwoTrainingReq] = useState(false);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/emp/query', {
        page: currentPage,
        pageSize,
        search,
        active_status: activeStatus
      });
      const { data, total } = response.data;
      setTableData(data);
      setTotalRows(total);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleExportCsv = () => {
    const formattedData = tableData.map((item) => {
      return ({
        ...item,
        created_at: moment(item.created_at).format('DD-MM-YYYY hh:mm a'),
      })
    });

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportCsv(tCols, formattedData, `Employees_${moment().format('DD-MM-YYYY')}`);
  };

  const handleExportPdf = () => {
    const formattedData = tableData.map((item) => {
      return ({
        ...item,
        created_at: moment(item.created_at).format('DD-MM-YYYY hh:mm a'),
      })
    });

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportPdf(tCols, formattedData, `Employees_${moment().format('DD-MM-YYYY')}`);
  };

  useEffect(() => {
    fetchTableData();
    if (reload) setReload(false)
  }, [currentPage, pageSize, search, reload]);

  const exportMenuItems = [
    {
      label: 'Export CSV',
      key: 1,
      icon: <DownloadOutlined />,
    },
    {
      label: 'Export PDF',
      key: 2,
      icon: <DownloadOutlined />,
    },
  ];

  const handleExportMenuClick = (event) => {
    let { key } = event;
    key = Number(key)
    if (key === 1) {
      handleExportCsv();
    } else if (key === 2) {
      handleExportPdf();
    }
  };

  const exportMenuProps = {
    items: exportMenuItems,
    onClick: handleExportMenuClick,
  };

  const handleEditRowClck = (event) => {
    const { currentTarget } = event;
    const dataID = Number(currentTarget.getAttribute('data-index') || 0)
    setEditID(dataID)
    setShowForm(true)
  }

  const handleDeleteRowClck = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setBusy(true)
        const response = await DataService.post('/emp/change-status', {
          id: dataID,
          status: !Boolean(dbRec.is_active)
        });

        const { status } = response.data;
        if (status) {
          setReload(true)
          message.success(response.data.message)
        } else {
          message.error(response.data.message)
        }
        setBusy(false)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const handleCardPrintClick = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setBusy(true)
        const response = await DataService.post('/e-card/request', { id: dataID });
        const { status } = response.data;

        if (status) {
          setReload(true)
          message.success(response.data.message)
        } else {
          message.error(response.data.message)
        }
        setBusy(false)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const handleFireRowClick = async (event) => {
    try {
      setBusy(true)
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setEditID(dataID)
        setShowEndEmp(true);
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const handleTrainingRequestRowClick = async (event) => {
    try {
      setBusy(true)
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setEditID(dataID)
        setShwoTrainingReq(true);
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const TableColumns = [
    {
      title: '',
      dataIndex: 'profile_picture',
      key: 'profile_picture',
      field: 'profile_picture',
      export: false,
      onCell: () => ({ className: 'w-20 text-center' }),
      render: (profile_picture) => {
        return (<Avatar
          className='cursor-pointer'
          src={profile_picture ? `${API_ENDPOINT}/${profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
          size={40}
          onClick={(event) => {
            if (profile_picture) {
              setProfilePicture(`${API_ENDPOINT}/${profile_picture}`)
              setIsImageModalOpen(true)
            } else {
              message.info('No profile image');
            }
          }}
        />)
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      field: 'name',
      export: true,
    },
    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      field: 'contact',
      onCell: () => ({ className: 'w-40 text-center' }),
      export: true,
    },
    {
      title: 'CNIC',
      dataIndex: 'cnic',
      key: 'cnic',
      field: 'cnic',
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },
    {
      title: 'Reg: Date',
      dataIndex: 'created_at',
      key: 'created_at',
      field: 'created_at',
      onCell: () => ({ className: 'w-40 text-center' }),
      export: true,
      // onCell: () => ({
      //   style: { textAlign: 'center' },
      // }),
      render: (text) => moment(text).format('YYYY-MM-DD hh:mm a'),
    },
    {
      title: 'IsEmployed',
      dataIndex: 'is_employeed',
      key: 'is_employeed',
      field: 'is_employeed',
      onCell: () => ({ className: 'w-10' }),
      export: true,
      render: (is_employeed) => {
        let color = themeColor['danger-color']
        let lblStr = 'Fired';

        if (Boolean(is_employeed)) {
          lblStr = 'Working'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'IsActive',
      dataIndex: 'is_active',
      key: 'is_active',
      field: 'is_active',
      onCell: () => ({ className: 'w-10' }),
      export: true,
      render: (is_active) => {
        let color = themeColor['danger-color']
        let lblStr = 'InActive';

        if (Boolean(is_active)) {
          lblStr = 'Active'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Actions',
      export: false,
      width: 10,
      onCell: () => ({ className: 'w-20' }),
      render: (rowData) => {
        // console.log('rowData', rowData)
        return (<div className='flex flex-row justify-between select-none'>
          {rowData.is_employeed ? <>
            <Tooltip title='Edit Record' className='select-none'>
              <BtnWithIcon
                onClick={handleEditRowClck}
                data-index={rowData.id}
              >
                <UilPen
                  className='hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                  size={20}
                />
              </BtnWithIcon>
            </Tooltip>
            <Tooltip title={`${rowData.status ? 'Block' : 'Unblock'} record`} className='select-none'>
              <Popconfirm
                title={`Are you sure to ${rowData.status ? 'inactive' : 'active'} this "${rowData.name}" employee ?`}
                onConfirm={handleDeleteRowClck}
                okButtonProps={{
                  'data-index': rowData.id
                }}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <BtnWithIcon className='ninjadash-delete'>
                  {rowData.status ?
                    <UilLock
                      className='ninjadash-delete hover:scale-110 hover:text-red-500 hover:cursor-pointer transform transition duration-300 ease-in-out'
                      size={20}
                    />
                    :
                    <UilUnLock
                      className='ninjadash-delete hover:scale-110 hover:text-green-500 hover:cursor-pointer transform transition duration-300 ease-in-out'
                      size={20}
                    />
                  }
                </BtnWithIcon>
              </Popconfirm>
            </Tooltip>
            <Tooltip title='Fire Employee' className='select-none'>
              <BtnWithIcon
                onClick={handleFireRowClick}
                data-index={rowData.id}
              >
                <UilFire
                  className='hover:scale-110 hover:text-red-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                  size={20}
                />
              </BtnWithIcon>
            </Tooltip>
            <Tooltip title='Trainign Request' className='select-none'>
              <BtnWithIcon
                onClick={handleTrainingRequestRowClick}
                data-index={rowData.id}
              >
                <UilBookAlt
                  className='hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                  size={20}
                />
              </BtnWithIcon>
            </Tooltip>
            <Tooltip title='e-Card printing request' className='select-none'>
              <Popconfirm
                title={`Are you sure to generate e-card printing request for this "${rowData.name}" employee ?`}
                onConfirm={handleCardPrintClick}
                okButtonProps={{
                  'data-index': rowData.id
                }}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <BtnWithIcon className='ninjadash-delete'>
                  <UilCreditCard
                    className='ninjadash-delete hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                </BtnWithIcon>
              </Popconfirm>
            </Tooltip>
          </>
            : ''}
        </div >
        )
      },
    },
  ];

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Registered Employees" routes={[]} />
      <Main>
        <ImagePreview
          visible={isImageModalOpen}
          imageSrc={profilePicture}
          onClose={() => {
            setProfilePicture(null)
            setIsImageModalOpen(false)
          }}
        />
        {showEndEmp && <EndEmployement onClose={() => setShowEndEmp(false)} onFinish={() => setReload(true)} visible={showEndEmp} empID={editID} />}

        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <Input
              className=" hover:drop-shadow-xl hover:border-solid hover:border-1 hover:border-blue-800 rounded-sm w-1/4"
              size='small'
              autoFocus
              placeholder="Search Anything"
              prefix={<UilSearch size={15} />}
              defaultValue={search}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <div className="flex space-x-2">
              <Select
                placeholder="Active Status"
                value={activeStatus}
                onChange={(value) => {
                  setActiveStatus(value)
                  setTimeout(() => {
                    setReload(true)
                  }, 200);
                }}
              >
                {EMP_STATUS_FILTER.map((reason) => (
                  <Option key={reason.id} value={reason.id}>
                    {reason.label}
                  </Option>
                ))}
              </Select>

              <Dropdown menu={exportMenuProps}>
                <Button className='h-9'>
                  <Space>
                    Export Data
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
              <Button type="primary" onClick={(event) => {
                setShowForm(true)
              }}>
                Add New
              </Button>
              {/* <FontAwesome icon="fa-sharp fa-solid fa-file-pdf" /> */}

            </div>
          </div>
          <div className="ninjadasj-datatable">
            <TableWrapper >
              <Table
                rowKey={(record) => `${record.id}`} // Generate a unique key for each row
                loading={busy}
                key={`${currentPage}-${pageSize}`} // Add a unique key to force re-render
                bordered
                virutal
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={tableData}
                columns={TableColumns}
              />
            </TableWrapper>
          </div>
        </div>
        {showForm && <FormDialog showDialog={() => { setShowForm(false); setEditID(null) }} setReload={setReload} editId={editID || null} isEdit={editID || false} />}
        {shwoTrainingReq && <TrainingsSelection showDialog={() => { setShwoTrainingReq(false); setEditID(null) }} setReload={setReload} editId={editID || null} isEdit={editID || false} />}
      </Main>
    </>
  );
}

export default DataTable;
